

















































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeSuprimentosStore from '@/components/Backoffice/Store/BackofficeSuprimentosStore'
import { onlyFloat, timeout } from '@/utils/common'
import EventBus from '@/plugins/EventBus'
import { Procedimento, OpmeMaterial, GrupoOpmes } from '@/types/_'
import { StatusDoProtocoloEnum } from '@/types/interfaces/protocolo/status-do-protocolo.enum'

@Component
export default class ModalAlterarMateriais extends Vue {
  $refs!: {
    solicitacaoAlteradaForm: any,
    opmeForm: any
  }

  solicitacaoAlteradaForm: any = {
    valid: true,
  }

  loadCancelar: boolean = false
  loadFechar: boolean = false
  loadAlterar: boolean = false
  loadOpme: boolean = false
  loadRemoveGrupoOpme: string = ''
  loadRemoveOpmeGrupoOpme: string = ''
  loadEditarFornecedores: string = ''
  lastSelectedEquipmentsBeforeHospitalChange: string[] = []

  opmeRules = {
    id: [v => !!v || 'Campo obrigatório'],
    quantidade: [v => !!v || 'Campo obrigatório'],
    fornecedor1: [v => !!v || 'Campo obrigatório'],
    fornecedor2: [],
    fornecedor3: [],
  }

  get loadingEditarFornecedores() {
    return this.loadEditarFornecedores
  }

  set loadingEditarFornecedores(value: string) {
    this.loadEditarFornecedores = value
  }

  get formulario() {
    return this.getBackofficeGlobalStore.template.formulario
  }

  get fornecedorLabel() {
    return this.formulario && this.formulario.opmes && this.formulario.opmes.fornecedorLabel
      ? this.formulario.opmes.fornecedorLabel
      : 'fornecedor / marca'
  }

  get loadingCancelar() {
    return this.loadCancelar
  }

  set loadingCancelar(value: boolean) {
    this.loadCancelar = value
  }

  get loadingFechar() {
    return this.loadFechar
  }

  set loadingFechar(value: boolean) {
    this.loadFechar = value
  }

  get loadingAlterar() {
    return this.loadAlterar
  }

  set loadingAlterar(value: boolean) {
    this.loadAlterar = value
  }

  get loadingRemoveGrupoOpme() {
    return this.loadRemoveGrupoOpme
  }

  set loadingRemoveGrupoOpme(value: string) {
    this.loadRemoveGrupoOpme = value
  }

  get loadingRemoveOpmeGrupoOpme() {
    return this.loadRemoveOpmeGrupoOpme
  }

  set loadingRemoveOpmeGrupoOpme(value: string) {
    this.loadRemoveOpmeGrupoOpme = value
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeSuprimentosStore() {
    return getModule(BackofficeSuprimentosStore, this.$store)
  }

  get showModalAlterarMateriais() {
    return this.getBackofficeGlobalStore.modal.alterarMaterial
  }

  set showModalAlterarMateriais(value: boolean) {
    this.getBackofficeGlobalStore.setModal({ name: 'alterarMaterial', value })
  }

  get loadingOpme() {
    return this.loadOpme
  }

  set loadingOpme(value: boolean) {
    this.loadOpme = value
  }

  get grupoOpmeDaSolicitacao() {
    return this.getBackofficeGlobalStore.solicitacaoAlterada.grupoOpmeDaSolicitacao
  }

  modalOpmeChange() {
    this.$forceUpdate()
  }

  onlyFloatUtil(value: number) {
    return onlyFloat(value)
  }

  materialChange(data: OpmeMaterial, index: number) {
    this.getBackofficeGlobalStore.materialChange({ opme: data, index })
  }

  adicionarOpme() {
    this.getBackofficeGlobalStore.adicionarOpme()
    this.$forceUpdate()
  }

  deleteOpme(index: number) {
    if (this.getBackofficeGlobalStore.solicitacaoAlterada.grupoDeOpme!.opmes.length === 1) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Pelo menos 1 (um) material é obrigatório.', icon: 'warning', color: '#C62828' })
      return
    }
    this.getBackofficeGlobalStore.deleteOpme(index)
    this.$forceUpdate()
  }

  gradeCompletaChange(data: GrupoOpmes) {
    data.observacao = ''
    this.$forceUpdate()
  }

  showModalCadastrarMaterial() {
    this.getBackofficeGlobalStore.setShowModalCadastrarMaterial(true)
  }

  showModalCadastrarFornecedor() {
    this.getBackofficeGlobalStore.setShowModalCadastrarFornecedor(true)
  }

  async deleteOpmeFromGrupoOpme(grupoOpmeId: string, opmeId: string) {
    this.loadingRemoveOpmeGrupoOpme = `${grupoOpmeId}${opmeId}`
    await this.getBackofficeGlobalStore.removerOpmeDoGrupo({ grupoOpmeId, opmeId })
    this.loadingRemoveOpmeGrupoOpme = ''
  }

  async showModalOpme() {
    this.loadingOpme = true
    if (this.getBackofficeGlobalStore.procedimentoPrincipal && this.getBackofficeGlobalStore.procedimentoPrincipal.id !== '' && !!this.getBackofficeGlobalStore.procedimentosAssociados) {
      const { procedimentoPrincipal, procedimentosAssociados } = this.getBackofficeGlobalStore
      const codigoProcedimentos: any[] = []
      if (procedimentosAssociados.length > 0) {
        procedimentosAssociados.forEach((e: Procedimento) => codigoProcedimentos.push(e.codigo))
      }
      codigoProcedimentos.unshift(procedimentoPrincipal.codigo)
      await this.getBackofficeGlobalStore.getGrupoOpmeByMedico(codigoProcedimentos)
      this.getBackofficeGlobalStore.setModal({ name: 'editarOpme', value: true })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Procedimento principal não foi selecionado.', icon: 'warning', color: '#C62828' })
    }
    this.loadingOpme = false
  }

  campoHabilitado(prop: string) {
    if (this.getBackofficeGlobalStore.template.formulario) {
      const response = this.getBackofficeGlobalStore.template.formulario[prop]

      if (response) return response.habilitado
    }

    return false
  }

  opcaoHabilitado(prop1: string, prop2: string) {
    if (this.getBackofficeGlobalStore.template.formulario) {
      const response = this.getBackofficeGlobalStore.template.formulario[prop1]
        && this.getBackofficeGlobalStore.template.formulario[prop1].campos
        && this.getBackofficeGlobalStore.template.formulario[prop1].campos[prop2]
      return response
    }
    return false
  }

  get template() {
    return this.getBackofficeGlobalStore.template
  }

  possuiOMesmoFornecedor(id1: string | undefined, id2: string | undefined, id3: string | undefined) {
    id1 = id1 || 'id1'
    id2 = id2 || 'id2'
    id3 = id3 || 'id3'

    if (
      id1 === id2
      || id1 === id3
      || id2 === id3
    ) {
      return true
    }

    return false
  }

  possuiFornecedoresDuplicados() {
    const exists = !this.getBackofficeGlobalStore.solicitacaoAlterada.grupoDeOpme!.opmes.every((opme) => {
      const { fornecedor1Id, fornecedor2Id, fornecedor3Id } = opme
      return !this.possuiOMesmoFornecedor(fornecedor1Id, fornecedor2Id, fornecedor3Id)
    })

    if (exists) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Existem materiais com fornecedores duplicados, revise a lista de materiais.', icon: 'warning', color: '#C62828', timeout: 5500 })
    }

    return exists
  }

  async alterarMateriais() {
    if (this.possuiFornecedoresDuplicados()) {
      return
    }

    this.loadingAlterar = true

    this.$refs.solicitacaoAlteradaForm.validate()
    const solicitacaoAlteradaFormErrors = await this.$refs.solicitacaoAlteradaForm.errorBag

    this.$refs.opmeForm.validate()
    const errorsOpmeForm = await this.$refs.opmeForm.errorBag

    let counterValid = Object.values(solicitacaoAlteradaFormErrors).filter(e => e === true).length
    counterValid += Object.values(errorsOpmeForm).filter(e => e === true).length

    if (counterValid < 1) {
      const response = await this.getBackofficeGlobalStore.backofficeAgendamentoAtualizaSolicitacao()
      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Materiais alterados com sucesso!', icon: 'done', color: '#2E7D32', timeout: 4000 })
        await this.getBackofficeSuprimentosStore.loadAgendamentosMedicoSearch()
        await this.closeModal()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao alterar os materiais.', icon: 'warning', color: '#C62828', timeout: 4000 })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: `Foram encontrados ${counterValid} erro(s).`, icon: 'warning', color: '#C62828' })
    }

    this.loadingAlterar = false
  }

  async fechar(botao: string) {
    const btn: string = botao.toUpperCase() === 'CANCELAR' ? 'loadingCancelar' : 'loadingFechar'
    this[btn] = true
    await timeout(500)
    await this.closeModal()
    this.showModalAlterarMateriais = false
    this[btn] = false
  }

  async closeModal() {
    await this.getBackofficeGlobalStore.desbloquearSolicitacao(this.getBackofficeGlobalStore.solicitacaoAlterada.solicitacaoId)
    this.getBackofficeGlobalStore.clearSolicitacaoAlterada()
    this.getBackofficeGlobalStore.clearGrupoOpmeDaSolicitacao()
    this.getBackofficeGlobalStore.clearTemplate()
    this.$refs.solicitacaoAlteradaForm.reset()
    this.$refs.solicitacaoAlteradaForm.resetValidation()
    this.getBackofficeGlobalStore.setModal({ name: 'alterarMaterial', value: false })
    this.lastSelectedEquipmentsBeforeHospitalChange = []
  }

  @Watch('showModalAlterarMateriais')
  onChangeShowModalAlterarMateriais(value: boolean) {
    if (value) this.$refs.solicitacaoAlteradaForm.resetValidation()
  }

  get temNaoInformadoComoFornecedor() {
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacaoAlterada
    if (grupoOpmeDaSolicitacao.length === 0) return false
    const algumNaoInformado: boolean[] = []
    grupoOpmeDaSolicitacao.forEach((grupo: any) => {
      grupo.opmes.forEach((opme: any) => {
        if (!opme.fornecedor1) algumNaoInformado.push(false)
        if (!opme.fornecedor2) algumNaoInformado.push(false)
        if (!opme.fornecedor3) algumNaoInformado.push(false)

        // Caso não exista a flag de alertaFornecedorNaoInformado, utilizar o método antigo
        const invalido = (f: string) => {
          const e = f
          return opme[e] === undefined
            ? false
            : opme[e].nome.toUpperCase() === 'NÃO INFORMADO' || !!opme[e].alertaFornecedorNaoInformado
        }

        algumNaoInformado.push(invalido('fornecedor1'))
        algumNaoInformado.push(invalido('fornecedor2'))
        algumNaoInformado.push(invalido('fornecedor3'))
      })
    })
    return algumNaoInformado.some((e: boolean) => e)
  }

  get temNaoHomologadoComoFornecedor() {
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacaoAlterada
    if (grupoOpmeDaSolicitacao.length === 0) return false
    const algumNaoHomologado: boolean[] = []
    grupoOpmeDaSolicitacao.forEach((grupo: any) => {
      grupo.opmes.forEach((opme: any) => {
        if (!opme.fornecedor1) algumNaoHomologado.push(false)
        if (!opme.fornecedor2) algumNaoHomologado.push(false)
        if (!opme.fornecedor3) algumNaoHomologado.push(false)

        algumNaoHomologado.push(!!opme.fornecedor1 && !!opme.fornecedor1.alertaFornecedorNaoHomologado)
        algumNaoHomologado.push(!!opme.fornecedor2 && !!opme.fornecedor2.alertaFornecedorNaoHomologado)
        algumNaoHomologado.push(!!opme.fornecedor3 && !!opme.fornecedor3.alertaFornecedorNaoHomologado)
      })
    })
    return algumNaoHomologado.some((e: boolean) => e)
  }

  async openModalEditarFornecedorOPME(flag: string) {
    this.loadingEditarFornecedores = flag
    const request = await this.getBackofficeGlobalStore.getFornecedoresFromApi('solicitacaoAlterada')
    if (request && request.length > 0) {
      this.getBackofficeGlobalStore.setModal({ name: 'modalEditarFornecedorOPME', value: true })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message || `Ocorreu um erro ao buscar fornecedores... ${String.fromCodePoint(0x1f615)}`, icon: 'warning', color: '#C62828' })
    }
    this.loadingEditarFornecedores = ''
  }

  canAddOrDeleteOpme() {
    return !this.getBackofficeGlobalStore.solicitacaoAlterada.protocoloDeCirurgia
      || (this.getBackofficeGlobalStore.solicitacaoAlterada.protocoloDeCirurgia
      && this.getBackofficeGlobalStore.solicitacaoAlterada.protocoloDeCirurgia.segueOProtocolo === StatusDoProtocoloEnum.naoSegueOProtocolo)
  }
}
